const diplomasArr = [
  {
    category: "Взрослые",
    image: "../../../img/diplomas/dip1.jpg",
    achieveType: "Диплом",
  },
  {
    category: "Взрослые",
    image: "../../../img/diplomas/dip2.jpg",
    achieveType: "Диплом",
  },
  {
    category: "Молодежь",
    image: "../../../img/diplomas/dip3.jpg",
    achieveType: "Диплом",
  },
  {
    category: "Всероссийские соревнования",
    image: "../../../img/diplomas/dip4.jpg",
    achieveType: "Диплом",
  },
  {
    category: "Молодежь 2",
    image: "../../../img/diplomas/dip5.jpg",
    achieveType: "Диплом",
  },
  {
    category: "Взрослые",
    image: "../../../img/diplomas/dip6.jpg",
    achieveType: "Диплом",
  },
  {
    category: "Взрослые",
    image: "../../../img/diplomas/dip7.jpg",
    achieveType: "Диплом",
  },
  {
    category: "Молодежь",
    image: "../../../img/diplomas/dip8.jpg",
    achieveType: "Диплом",
  },
];

diplomasArr.forEach((el) => {
  $(".diplomas .swiper-wrapper").append(`
        <a href="${el.image}" data-fancybox="achievements_gallery" class="diploma swiper-slide">
            <img src=${el.image} />
            <p class="diploma__name">${el.achieveType}</p>
            <p class="diploma__value">Возрастная категория ${el.category}</p>
            <div class="diploma__triangle"></div>
            <div class="diploma__rounded">
                <div class="diploma__rounded-circle"></div>
            </div>
        </a>
    `);
});

const diplomasSlider = new Swiper(".diplomas", {
  spaceBetween: 12,
  autoplay: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    420: {
      slidesPerView: 2,
    },
    600: {
      slidesPerView: 3,
    },
    900: {
      slidesPerView: 4,
    },
    1075: {
      slidesPerView: 5,
    },
  },
});

$(".achievements__top-arrows .arrow.prev").on("click", () => {
  diplomasSlider.slidePrev();
});

$(".achievements__top-arrows .arrow.next").on("click", () => {
  diplomasSlider.slideNext();
});
